import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useEntityList, deleteEntity } from '../data/entities';
import NewWorkflowForm, { friendlyWriteError } from './NewWorkflowForm';

// nQube pipelines of one workspace: list + create + delete. Shared by the
// workspace page and the project-scoped nQube module (same data — pipelines
// are workspace-scoped). The canvas itself lives in PipelineEditor.
export default function WorkspacePipelines({ orgId, workspaceId, compact = false }) {
  const scope = { org: orgId, workspace: workspaceId };
  const { docs: pipelines, error: loadError } = useEntityList('pipeline', scope);
  const [deleteError, setDeleteError] = useState('');

  return (
    <section style={{ marginTop: compact ? 12 : 28 }}>
      {!compact && (
        <>
          <h2 style={{ margin: 0 }}>nQube · Pipelines</h2>
          <p className="cs-help" style={{ marginTop: 4 }}>
            Build visually with nQube blocks — pipelines run on the fan-out job
            system and are cancellable from Jobs.
          </p>
        </>
      )}
      <NewWorkflowForm orgId={orgId} workspaceId={workspaceId} placeholder="New pipeline name…" style={{ marginTop: 12 }} />

      {(loadError || deleteError) && (
        <p className="cs-form-error" style={{ marginTop: 10 }}>{deleteError || `Could not load pipelines: ${loadError}`}</p>
      )}
      {pipelines && !pipelines.length && (
        <div className="cs-empty" style={{ marginTop: 14 }}>No pipelines yet.</div>
      )}
      <div style={{ display: 'grid', gap: 10, marginTop: 14 }}>
        {(pipelines || []).map((p) => (
          <Link
            key={p.id}
            to={`/orgs/${orgId}/ws/${workspaceId}/pipelines/${p.id}`}
            className="cs-card"
            style={{ padding: 14, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}
          >
            <strong style={{ color: 'var(--text)' }}>{p.name}</strong>
            <span className="cs-help" style={{ fontSize: 12 }}>
              {(p.graph?.blocks || []).length} block{(p.graph?.blocks || []).length === 1 ? '' : 's'}
            </span>
            <span style={{ flex: 1 }} />
            {p.lastRun?.finishedAt && (
              <span className="cs-help" style={{ fontSize: 12 }}>
                last run {new Date(p.lastRun.finishedAt).toLocaleString()}
              </span>
            )}
            <button
              className="cs-btn cs-btn-outline cs-btn-sm"
              onClick={async (e) => {
                e.preventDefault();
                // eslint-disable-next-line no-alert
                if (window.confirm(`Delete pipeline "${p.name}"?`)) {
                  try {
                    await deleteEntity('pipeline', scope, p.id);
                  } catch (err) {
                    setDeleteError(friendlyWriteError(err));
                  }
                }
              }}
            >
              Delete
            </button>
          </Link>
        ))}
      </div>
    </section>
  );
}
